import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Grid, {
  GridColumn,
  GridHeader,
  GridRow,
} from "../../../components/Grid/Grid";
import HelperService from "../../../utility/HelperService";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import WebService from "../../../utility/WebService";
import { toast } from "react-toastify";
import ChangePassword from "../UserPageModal/ChangePassword";
import AddUser from "../UserPageModal/AddUser";
import { permissionsInterface } from "../../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import { PiExport } from "react-icons/pi";

const headers: GridHeader[] = [
  {
    title: "Name",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "first_name",
  },
  {
    title: "Email",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "email",
  },
  {
    title: "Phone Number",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "phone",
  },
  {
    title: "Date",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const Users = () => {
  const navigate = useNavigate();
  const nextOffset = useRef<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expenseId, setExpenseId] = useState<string>("");
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [rows, setRows] = useState<GridRow[]>([]);
  const rowCompute = useRef<GridRow[]>([]);
  const [showChangePassword, setChangePassword] = useState<boolean>(false);
  const [userUUID, setUserUUID] = useState<string>("");
  const [showAddUser, setAddUser] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [totalCount, setTotalCount] = useState<number>(0);

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "USERS"));
    }
  }, [token])

  const actionList = (data: any) => {
    return (
      <div className="action-btns">
        {permissions && permissions.can_update && <>
          <button
            className="cursor-pointer btn-pass btn"
            onClick={() => {
              setUserUUID(data.uuid);
              setChangePassword(true);
            }}
          >
            <span className="badge text-warning">Reset Password</span>{" "}
          </button>
          <button
            className="cursor-pointer  btn-edit btn"
            onClick={() => onEdit(data)}
          >
            {" "}
            <Pencil />{" "}
          </button>
        </>}
        {permissions && permissions.can_delete && <button
          onClick={() => onConfirmDelete(data)}
          className="cursor-pointer btn btn-delete"
        >
          {" "}
          <Trash />{" "}
        </button>}
      </div>
    );
  };

  const onEdit = (val: any) => {
    setEditData(val);
    setAddUser(true);
  };

  const onConfirmDelete = (val: any) => {
    setExpenseId(val.uuid);
    setDeleteModal(true);
  };

  const getUsersList = (
    offset: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    order_by?: string,
    sort_by?: string
  ) => {
    nextOffset.current = offset;
    if (nextOffset.current < 0 || isLoading) {
      return;
    }
    nextOffset.current == 0 && setIsLoading(true);
    WebService.getAPI({
      action: `user/pagination/list?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
        }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
        }`,
      body: null,
    })
      .then((res: any) => {
        setIsLoading(false);
        let rows: GridRow[] = [];
        for (var i in res.list) {
          let columns: GridColumn[] = [];
          columns.push({
            value: res.list[i].first_name + " " + res.list[i].last_name,
          });
          columns.push({
            value: res.list[i].email ? res.list[i].email : "N/A",
          });
          columns.push({
            value: res.list[i].phone
              ? HelperService.getFormattedContact(res.list[i].phone)
              : "N/A",
          });
          columns.push({
            value:
              res.list[i].created_at &&
              HelperService.getFormatedDate(res.list[i].created_at),
          });
          columns.push({ value: actionList(res.list[i]), type: "COMPONENT" });
          rowCompute.current.push({ data: columns });
          rows.push({ data: columns });
        }
        rowCompute.current = rows;
        setRows(rowCompute.current);
        setTotalCount(res.count);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getUsersList(
      offset,
      null as any,
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    );
  };

  const onDelete = () => {
    setDeleteModal(false);
    setIsLoading(true);
    WebService.deleteAPI({
      action: `user/delete/${expenseId}`,
      body: null,
    })
      .then((res: any) => {
        setIsLoading(false);
        toast.success(res.message);
        setExpenseId("");
        getUsersList(1);
      })
      .catch((e) => {
        setIsLoading(false);
        setExpenseId("");
      });
  };

  const onCloseUserModal = (e: boolean) => {
    setAddUser(false);
    setEditData({});
    e && getUsersList(1);
  };

  const exportUsers = () => {
    WebService.getAPI({
      action: `user/export`,
      body: null,
      responseType: 'arraybuffer',
    }).then((response: any) => {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `users_${new Date().toISOString()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }).catch((e) => {
      toast.error("Failed to export users");
    });
  };

  return (
    <>
      <ChangePassword isShow={showChangePassword} isClose={() => { setChangePassword(false); setUserUUID(""); }} uuid={userUUID} />
      <AddUser isShow={showAddUser} isClose={(e: boolean) => { onCloseUserModal(e); }} data={editData} />
      <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Users" backArrow={false} />
          <div>
            {permissions && permissions.can_write && <Button
              className="btn btn-brand-1 mb-3"
              onClick={() => {
                setEditData({});
                setAddUser(true);
              }}
            >
              <Plus size={20} className="ms-1" /> Add User
            </Button>}
            {permissions && permissions.can_write && permissions.can_update && <Button
              className="btn btn-brand-1 mb-3 ms-2"
              onClick={() => { exportUsers(); }}
            >
              <PiExport size={20} className="ms-1" /> Export
            </Button>}
          </div>
        </div>
        <div className="table-card">
          <Grid
            rows={rows}
            showSearch={true}
            headers={headers}
            showDateFilter={true}
            onPageChange={getUsersList}
            errorMessage={"No Users Found"}
            ShowLoader={isLoading}
            onSort={onSortList}
            count={totalCount}
          />
        </div>
      </div>}
    </>
  );
};

export default Users;
